<template>
  <div class="exper_index">
    <div class="logo_box">
      <img src="../../assets/images/logo.png" alt />
    </div>
    <div class="content">
      <div class="invitation">
        <div>想第一时间亲自体验蓝鲨新款产品吗？</div>
        <div>想让我们更好的倾听您的建议吗？</div>
        <div>想共同参与让蓝鲨的未来变得更好吗？</div>
      </div>
      <div class="rights">
        <h3>体验享有权益：</h3>
        <div>蓝鲨产品的“终身免费体验权”</div>
        <div>优先体验蓝鲨新品</div>
        <div>一旦提出优质的产品改善建议</div>
        <div>还可获得现金红包奖励</div>
      </div>
    </div>
    <div class="exper_btn_box" v-if="!preFlag">
      <button
        class="exper_btn"
        :class="{active:btnmousedown}"
        @click="preBtn"
        @touchstart="btnmousedown=true"
        @touchend="btnmousedown=false"
      >预约体验</button>
    </div>
    <div class="pre_tips" v-if="preFlag">
      <div>{{preInfo.user_info.name}}{{genderObj[preInfo.user_info.gender]}}</div>
      <div>您的预约体验资格我们正在审核中</div>
      <div>审核通过后我们将电话通知您,请留意接听</div>
      <div class="updateBtn">
        <button @click="updateInfo">修改预约信息</button>
      </div>
    </div>
    <van-popup v-model="showFill" closeable @close="closeFill" position="bottom">
      <div class="info_box">
        <div class="content_box" id="content_box">
          <div class="contact">留下您的联系方式，方便我们可以联系到您</div>
          <van-cell-group>
            <van-field id="i1" v-model="username" label="姓名" placeholder="请输入您的姓名" maxlength="10" />
            <van-field v-model="age" label="年龄"  placeholder="18 ~ 59" />
            <van-cell
              title="性别"
              is-link
              @click="genderPopup"
              arrow-direction="down"
              :value="gender"
              v-if="gender"
            ></van-cell>
            <van-cell
              title="性别"
              is-link
              @click="genderPopup"
              arrow-direction="down"
              value="请选择性别"
              v-if="!gender"
            ></van-cell>
            <van-cell
              title="地区"
              is-link
              @click="areaPopup"
              arrow-direction="down"
              :value="addressName"
              v-if="addressName"
            ></van-cell>
            <van-cell
              title="地区"
              is-link
              @click="areaPopup"
              arrow-direction="down"
              value="请选择所在地区"
              v-if="!addressName"
            ></van-cell>
            <van-field v-model="phone" label="联系方式" placeholder="请输入您的手机号" />
            <div class="message">体验宣言</div>
            <div style="padding: 0px 16px 10px;">
              <van-field
                v-model="message"
                type="textarea"
                maxlength="200"
                placeholder="200字描述"
                autosize
                id="mes"
                style="border:1px solid #c8c8c8;padding:0 6px;height:72px"
              />
            </div>
          </van-cell-group>
          <div class="exper_box">
            <button class="exper_btn" :class="allFill" @click="subBtn" v-if="!btnFlag">提交申请</button>
            <button class="exper_btn" :class="allFill" @click="updBtn" v-if="btnFlag">修改预约信息</button>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showgender" position="bottom">
      <van-picker
        show-toolbar
        :columns="genders"
        :default-index="genderIndex"
        @cancel="genderCancel"
        @confirm="genderConfirm"
      />
    </van-popup>
    <van-popup v-model="showaddress" position="bottom">
      <van-area
        :area-list="areaList"
        :value="addressValue"
        @cancel="addressCancel"
        @confirm="addressConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import apiApp from "../../utils/callApp";
import utils from "../../utils/index";
import areaList from "@/assets/js/area.js";
export default {
  data() {
    return {
      btnmousedown: false,
      preFlag: false,
      data: "",
      preInfo: {},
      genderObj: {
        1: "先生",
        2: "女士"
      },
      showFill: false, //填写信息弹出层
      username: "",
      age: "",
      phone: "",
      showgender: false,
      showaddress: false,
      genders: ["男", "女"],
      gendersIndex: {
        男: 1,
        女: 2
      },
      genderInfoObj: {
        1: "男",
        2: "女"
      },
      // gender: "请选择性别",
      gender: "",
      genderIndex: -1,
      addressValue: "110101", //选中地址省市县
      addressName: "",
      addressObj: null,
      areaList: null, //省市区json数据文件
      reverseArea: null, //交换key value省市区json数据文件
      message: "",
      code: "",
      preInfo: {},
      btnFlag: false,
      getDetailFlag: "" //0代表点击预约调取的detail 1代表closeFill
    };
  },
  created() {
    window.getTicket = this.getTicket;
    this.filterArea();
    this.exchangeArea();
  },
  mounted() {},
  computed: {
    allFill() {
      return {
        subactive: !(
          this.username &&
          this.age &&
          this.gender &&
          this.addressName &&
          this.phone &&
          this.message
        )
      };
    }
  },
  methods: {
    preBtn() {
      var req = { params: {}, callbackfunc: "getTicket" };
      apiApp.callApp("Native", "getTicketWithCallback", JSON.stringify(req));
      this.getDetailFlag = 0;
    },
    updateInfo() {
      this.showFill = true;
      this.getFillDetail();
    },
    getTicket(res) {
      //获取app 里面的token
      this.data = JSON.parse(res);
      if (res) {
        this.getDetail();
      }
    },
    getDetail() {
      let ts = utils.getts();
      let config = {
        headers: { Authorization: "Bearer " + this.data.ticket, ts: ts + "" }
      };
      this.$http
        .post(API_HOST + "/activity/experience/info", {}, config)
        .then(res => {
          if (res.body.data) {
            this.preFlag = true;
            this.preInfo = res.body.data;
          } else {
            this.preFlag = false;
            if (this.getDetailFlag == 1) {
              this.showFill = false;
            } else if (this.getDetailFlag == 0) {
              this.showFill = true;
            }
          }
        });
    },
    closeFill() {
      this.getDetailFlag = 1;
      this.getDetail();
      // this.$toast({
      //   message: JSON.stringify(this.showFill),
      //   duration: 2000
      // });
    },
    genderPopup() {
      this.showgender = true;
    },
    areaPopup() {
      this.showaddress = true;
    },
    genderConfirm(value, index) {
      this.gender = value;
      this.showgender = false;
    },
    genderCancel() {
      this.showgender = false;
    },
    addressConfirm(value) {
      this.addressName = value[0].name + value[1].name + value[2].name;
      this.addressObj = value;
      this.showaddress = false;
    },
    addressCancel() {
      this.showaddress = false;
    },
    // 处理城市数据(港澳台等城市除外)
    filterArea() {
      let newAreaList = {};
      let filterArr = [54, 65, 71, 81, 82, 90];
      for (let key in areaList) {
        newAreaList[key] = {};
        for (let key1 in areaList[key]) {
          if (
            key1.startsWith(54) ||
            key1.startsWith(65) ||
            key1.startsWith(71) ||
            key1.startsWith(81) ||
            key1.startsWith(82) ||
            key1.startsWith(90)
          ) {
            continue;
          }
          newAreaList[key][key1] = areaList[key][key1];
        }
      }
      this.areaList = newAreaList;
    },
    // 交换城市数据的key和value reverseArea
    exchangeArea() {
      let newAreaList = {};
      for (let key in areaList) {
        newAreaList[key] = {};
        for (let key1 in areaList[key]) {
          newAreaList[key][areaList[key][key1]] = key1;
        }
      }
      this.reverseArea = newAreaList;
    },
    // 提交验证
    subBtn() {
      let that = this;
      if (!this.allFill) {
        return;
      }
      if (!(this.age >=18 && this.age <= 59)) {
        this.$toast({
          message: "输入的年龄必须在18～59岁之间",
          duration: 1000
        });
        return
      }
      let reg_pn = /^[1][3-9][0-9]{9}$/;
      if (!reg_pn.test(this.phone)) {
        this.$toast({
          message: "手机号格式错误",
          duration: 1000
        });
        return;
      }
      let req = {
        phone: this.phone,
        declaration: this.message,
        address: {
          province: this.addressObj[0].name,
          city: this.addressObj[1].name,
          district: this.addressObj[2].name
        },
        user_info: {
          age: parseInt(this.age),
          name: this.username,
          gender: this.gendersIndex[this.gender]
        }
      };
      let ts = utils.getts();
      let config = {
        // headers: { Authorization: "Bearer " + "token2268815006c019c40aba842dfd97792a", ts: ts + "" }
        headers: { Authorization: "Bearer " + this.data.ticket, ts: ts + "" }
      };
      this.$http
        .post(
          API_HOST + "/activity/experience/submit",
          JSON.stringify(req),
          config
        )
        .then(res => {
          if (res.body.state == 0) {
            this.$dialog
              .alert({
                title: "恭喜您！",
                message:
                  "您已经预约成功，将有机会参加蓝鲨智能电动摩托车的体验活动",
                confirmButtonText: "我知道了"
              })
              .then(() => {
                this.showFill = false;
              });
          } else {
            this.$toast({
              message: "提交失败",
              duration: 1000
            });
          }
        });
    },
    updBtn() {
      let that = this;
      if (!this.allFill) {
        return;
      }
     if (!(this.age >=18 && this.age <= 59)) {
        this.$toast({
          message: "输入的年龄必须在18～59岁之间",
          duration: 1000
        });
        return
      }
      let reg_pn = /^[1][3-9][0-9]{9}$/;
      if (!reg_pn.test(this.phone)) {
        this.$toast({
          message: "手机号格式错误",
          duration: 1000
        });
        return;
      }
      let req = {
        phone: this.phone,
        declaration: this.message,
        address: {
          province: this.addressObj[0].name,
          city: this.addressObj[1].name,
          district: this.addressObj[2].name
        },
        user_info: {
          age: parseInt(this.age),
          name: this.username,
          gender: this.gendersIndex[this.gender]
        }
      };
      let ts = utils.getts();
      let config = {
        headers: { Authorization: "Bearer " + this.data.ticket, ts: ts + "" }
      };
      this.$http
        .post(
          API_HOST + "/activity/experience/update",
          JSON.stringify(req),
          config
        )
        .then(res => {
          if (res.body.state == 0) {
            this.$toast({
              message: "修改预约信息成功",
              duration: 1000
            });
          } else {
            this.$toast({
              message: "修改预约信息失败",
              duration: 1000
            });
          }
        });
    },
    getFillDetail() {
      //获取用户预约信息
      let ts = utils.getts();
      let config = {
        headers: {
          Authorization: "Bearer " + this.data.ticket,
          ts: ts + ""
        }
      };
      this.$http
        .post(API_HOST + "/activity/experience/info", {}, config)
        .then(res => {
          this.preInfo = res.body.data;
          let preInfo = this.preInfo;
          if (this.preInfo) {
            (this.username = preInfo.user_info.name),
              (this.age = preInfo.user_info.age),
              (this.gender = this.genderInfoObj[preInfo.user_info.gender]),
              (this.addressName =
                preInfo.address.province +
                preInfo.address.city +
                preInfo.address.district);
            this.addressObj = [
              { name: preInfo.address.province },
              { name: preInfo.address.city },
              { name: preInfo.address.district }
            ];
            this.phone = preInfo.phone;
            this.message = preInfo.declaration;
            this.addressValue = this.reverseArea.county_list[
              preInfo.address.district
            ];
            this.btnFlag = true;
            this.genderIndex = preInfo.user_info.gender - 1;
          }
        });
    }
  }
};
</script>

<style scoped>
.exper_index {
  color: white;
  height: 100%;
  background: url(../../assets/images/bg.png) no-repeat;
  background-size: cover;
}
.logo_box {
  padding: 60px 35px 20px;
}
.content {
  padding-left: 35px;
}
.exper_btn_box {
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 100px;
}
.exper_btn {
  height: 45px;
  line-height: 45px;
  width: 70%;
  background: linear-gradient(to right, #0072ff, #00c6ff);
  border-radius: 50px;
  border: 0;
  outline: none;
  color: #fff;
  letter-spacing: 2px;
  text-indent: 2px;
}
.active {
  background: #0072ff;
}
.logo_box img {
  width: 90%;
}
.rights h3 {
  margin-top: 20px;
  padding: 10px 0;
}
.rights div,
.invitation div {
  height: 24px;
  line-height: 24px;
}
.pre_tips {
  margin-top: 50px;
  padding-left: 35px;
}
.pre_tips div {
  line-height: 24px;
}
.updateBtn button {
  color: #00d2ff;
  background: none;
  border: 0;
  border-bottom: 1px solid #00d2ff;
  /* text-decoration: underline; */
}
/* fill */
.info_box {
  padding-top: 30px;
  font-size: 14px;
  color: gray;
}
.content_box {
  padding: 0 15px;
}
.message {
  padding: 10px 16px;
  font-size: 14px;
  color: #000;
}
#content_box .van-cell__title {
  width: 90px;
  flex: none;
}
#content_box .van-cell__value {
  text-align: left;
}
.exper_box {
  display: flex;
  justify-content: center;
  color: white;
  padding: 20px 0;
}
.exper_btn {
  height: 45px;
  line-height: 45px;
  width: 70%;
  background: linear-gradient(to right, #0072ff, #00c6ff);
  border-radius: 50px;
  border: 0;
  outline: none;
  color: #fff;
  letter-spacing: 2px;
  text-indent: 2px;
  user-select: none;
}
.subactive {
  background: #969696;
}
.contact {
  padding: 10px 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/exper/index.vue